define("shared/components/shared/media-items/post-card", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/object/computed", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _computed, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    <td>
      <Shared::ProfileAvatar @socialProfile={{@post.socialProfile}} @showDetails={{true}} @showPlatform={{true}} />
    </td>
    <td>
      {{this.postDisplayTime}}
    </td>
    <td class="u--text--right">
      {{#if @post.isInstagramStory}}
        <span class="u--text--light">
          {{t "shared_phrases.instagram_story"}}
        </span>
      {{else if this.postLocked}}
        <a class="o--btn o--btn--mute" {{action "editPost"}}>
          
        </a>
        <Shared::Ui::Button
          @type="mute"
          @onClick={{this.editPost}}
        >
          {{svg-jar "verified" class="o--icon o--icon--light u--m__r__xs"}}
          {{t "shared_words.posted"}}
        </Shared::Ui::Button>
      
      {{else}}
        <Shared::Ui::Button
          class="u--p__lr__md"
          @type="outline"
          @onClick={{this.editPost}}
        >
          {{t "shared_words.edit"}}
        </Shared::Ui::Button>
      {{/if}}
    </td>
  </tr>
  */
  {
    "id": "qHPjDs5Y",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@socialProfile\",\"@showDetails\",\"@showPlatform\"],[[30,1,[\"socialProfile\"]],true,true]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[12],[1,\"\\n    \"],[1,[30,0,[\"postDisplayTime\"]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"td\"],[14,0,\"u--text--right\"],[12],[1,\"\\n\"],[41,[30,1,[\"isInstagramStory\"]],[[[1,\"      \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_phrases.instagram_story\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"postLocked\"]],[[[1,\"      \"],[11,3],[24,0,\"o--btn o--btn--mute\"],[4,[38,3],[[30,0],\"editPost\"],null],[12],[1,\"\\n        \\n      \"],[13],[1,\"\\n      \"],[8,[39,4],null,[[\"@type\",\"@onClick\"],[\"mute\",[30,0,[\"editPost\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"verified\"],[[\"class\"],[\"o--icon o--icon--light u--m__r__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.posted\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \\n\"]],[]],[[[1,\"      \"],[8,[39,4],[[24,0,\"u--p__lr__md\"]],[[\"@type\",\"@onClick\"],[\"outline\",[30,0,[\"editPost\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.edit\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@post\"],false,[\"shared/profile-avatar\",\"if\",\"t\",\"action\",\"shared/ui/button\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/media-items/post-card.hbs",
    "isStrictMode": false
  });

  let PostCardComponent = (_dec = (0, _computed.reads)('args.post.locked'), (_class = class PostCardComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "userConfig", _descriptor, this);

      _initializerDefineProperty(this, "postLocked", _descriptor2, this);
    }

    get postDisplayTime() {
      return moment.unix(this.args.post.scheduledTime).tz(this.userConfig.currentTimeZone.identifier).format('MMM DD, h:mm a');
    }

    editPost() {
      if (!this.args.post.isInstagramStory) {
        this.args.editPost(this.args.post.id);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "postLocked", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "editPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype)), _class));
  _exports.default = PostCardComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PostCardComponent);
});